import { render } from "./AutosizeTextarea.vue?vue&type=template&id=11df6308"
import script from "./AutosizeTextarea.vue?vue&type=script&lang=js"
export * from "./AutosizeTextarea.vue?vue&type=script&lang=js"

import "./AutosizeTextarea.vue?vue&type=style&index=0&id=11df6308&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__